import api from "@/lib/api";

export const MAX_IMPORT_FILES = 1000;
const CHUNK_FILES = 20;
const CHUNK_BYTES = 40 * 1024 * 1024;

const makeChunks = (files) => {
  const chunks = [];
  let cur = [], size = 0;
  files.forEach((f) => {
    if (cur.length && (cur.length >= CHUNK_FILES || size + f.size > CHUNK_BYTES)) {
      chunks.push(cur); cur = []; size = 0;
    }
    cur.push(f); size += f.size;
  });
  if (cur.length) chunks.push(cur);
  return chunks;
};

// Envoie les fichiers par paquets dans un même job, puis lance le traitement.
export async function uploadImportJob(kind, files, onProgress) {
  const init = new FormData();
  init.append("kind", kind);
  const { data } = await api.post("/import-jobs/init", init);
  const jobId = data.job.id;
  try {
    let sent = 0;
    onProgress?.(0, files.length);
    for (const chunk of makeChunks(files)) {
      const fd = new FormData();
      chunk.forEach((f) => fd.append("files", f));
      await api.post(`/import-jobs/${jobId}/files`, fd,
        { headers: { "Content-Type": "multipart/form-data" } });
      sent += chunk.length;
      onProgress?.(sent, files.length);
    }
    const r = await api.post(`/import-jobs/${jobId}/start`);
    return r.data.job;
  } catch (e) {
    api.post(`/import-jobs/${jobId}/cancel`).catch(() => {});
    throw e;
  }
}
